/* =====================================================================
   ab-test-charm-v8.js — "Build Your Charm Set" Option 1A redesign A/B test
   (ab_charm_v8) — deferred work.

   Loaded ONLY on /products/build-your-charm-set (product-template.liquid).
   The inline assignment script there sets, before first paint:

       window.__charmAB = { name, variant:'A'|'B', active, fresh, cartAttr }
       html.charm-b (arm B only)

   This file:
     1. Stamps the ab_charm_test_v8 cart attribute for BOTH arms (the
        conversion source of truth — rides through checkout as an order
        attribute) and pushes the GA4 ab_test_assignment backup event.
     2. Arm B only: decorates the theme's charm-builder engine DOM into the
        Option 1A layout. The engine (1r-theme.js) stays the single source of
        truth for selection state and for the Add-to-cart payload — nothing
        here touches quantitiesById / customVariants / the ATC handler. We
        only:
          - restyle via html.charm-b (ab-test-charm-v8.css)
          - relabel the step titles, move "Charms starting at $8" up
          - compact the V4 quick-start cards ("Use set")
          - add price labels to base + charm cards
          - add search / metal + price chips / sort (client-side over the
            cards the engine rendered) and a "Load more" pager. Search
            matches title + option values + the custom.search_keywords
            metafield (rendered into window.__charmKeywords by
            product-template.liquid — products.json carries no metafields)
            plus a small tag-keyed synonym layer for category words; raw
            tags are NOT searched. Title hits rank above keyword hits.
          - mirror the engine's hidden step-3 result list into a sticky
            summary bar whose button IS an .add-to-cart-btn, so the engine's
            own delegated ATC handler runs unchanged
   Kill switch: ACTIVE=false in the inline script (product-template.liquid).
   ===================================================================== */
(function () {
  'use strict';

  var AB = window.__charmAB;
  if (!AB || !AB.active) return;
  var VARIANT = AB.variant === 'B' ? 'B' : 'A';
  var CART_ATTR = AB.cartAttr || 'ab_charm_test_v8';
  var GA4_TEST_NAME = 'charm_builder_1a_v8';

  /* ---------------------------------------------------------------
     1. Cart-attribute stamping + GA4 backup (both arms)
     --------------------------------------------------------------- */
  function stampCart() {
    var attrs = {};
    attrs[CART_ATTR] = VARIANT;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    });
  }
  function restamp() { stampCart().catch(function () { /* retried on add-to-cart */ }); }

  restamp();
  if (typeof jQuery !== 'undefined') {
    try {
      jQuery(document.body).on('afterAddItem.ajaxCart added.ajaxProduct afterAddToCart.ajaxCart', restamp);
    } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('.add-to-cart-btn, #ab-v4-atc-btn');
    if (t) setTimeout(restamp, 400);
  }, true);

  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'ab_test_assignment', ab_test_name: GA4_TEST_NAME, ab_test_variant: VARIANT });
  } catch (e) {}

  if (VARIANT !== 'B') return;

  /* ---------------------------------------------------------------
     2. Arm B — Option 1A decoration of the engine DOM
     --------------------------------------------------------------- */
  var PAGE_FIRST = 24;   // 12 columns of the 2-row strip
  var PAGE_STEP = 36;
  var CATALOG_URL = '/collections/charms/products.json?page=1&limit=250';
  var CUSTOM_TAGS = ['charm custom', 'custom-engravable-new', 'flower-builder', 'starmap-charm',
    'pet-portrait-charm', 'photo upload', 'non-photo-custom', 'personalized-jersey-charm',
    'locket-heart', 'locket-oval-verticle'];
  // Category words, keyed by the tag that defines the category. This is the
  // only thing tags feed into search: "birthstone" / "zodiac" / "initial"
  // should find the whole family without being repeated on every product's
  // keyword list. Per-product words live in custom.search_keywords.
  var SYNONYMS = {
    'charm letter': 'initial initials letter alphabet monogram',
    'letter': 'initial initials alphabet',
    'birthstone': 'birthstone birth stone month gem',
    'number charm': 'number digit year',
    'charm zodiac': 'zodiac astrology sign horoscope',
    'charm personalized': 'personalized custom',
    'charm custom': 'custom personalized engraved',
    'photo upload': 'photo picture upload',
    'sport charm': 'sport sports team',
    'seasonal-charm': 'seasonal holiday',
    'charm spiritual': 'spiritual celestial faith',
    'halloween': 'halloween spooky october'
  };
  // Query-side spelling aliases the prefix rule cannot bridge (a longer or
  // differently-suffixed query never prefix-matches the shorter index word).
  var QUERY_ALIASES = { sparkle: 'sparkly', sparkles: 'sparkly', sparkling: 'sparkly', grandmother: 'grandma', grandmothers: 'grandma' };
  var STOPWORDS = { of: 1, the: 1, and: 1, a: 1, an: 1, for: 1, to: 1, with: 1, my: 1 };
  // productId -> [keyword, ...] from custom.search_keywords (inline Liquid)
  var KEYWORDS = window.__charmKeywords || {};

  var info = {};          // variantId -> { price, metal, custom, sticker, title, keywords }
  var catalogReady = false;
  var state = { q: '', metal: '', under10: false, sort: 'default', cap: PAGE_FIRST, metalTouched: false };
  var form, meta, charmsBox, resultBox, step1Title, step2Title, baseTypes, baseBox;
  var bar, barThumbs, barLabel, barPrice, barBtn, emptyMsg, statusEl, chipEls = {}, sortSel, searchInput;
  var remaining = 0;      // cards matching the filters but beyond the cap
  var forwarding = false; // true while we re-dispatch a click into the engine's overlay

  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }
  function txt(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function money(n) {
    n = Number(n);
    if (isNaN(n)) return '';
    return n % 1 === 0 ? '$' + n : '$' + n.toFixed(2);
  }
  function parsePrice(node) {
    // result rows read "<title><br><s>$compare</s> $price" — the LAST $ is the price
    var m = (node ? node.textContent : '').match(/\$\s*([\d.]+)/g);
    if (!m || !m.length) return NaN;
    return parseFloat(m[m.length - 1].replace(/[^\d.]/g, ''));
  }
  function raf(fn) {
    var pending = false;
    return function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () { pending = false; fn(); });
    };
  }
  function metalOf(v, p) {
    var s = [v.option1, v.option2, v.option3, v.title, p.title].join(' ');
    if (/rose\s*gold/i.test(s)) return 'Gold';
    if (/gold/i.test(s)) return 'Gold';
    if (/silver/i.test(s)) return 'Silver';
    return '';
  }
  function loadCatalog() {
    return fetch(CATALOG_URL)
      .then(function (r) { return r.json(); })
      .then(function (res) {
        (res.products || []).forEach(function (p) {
          var tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',').map(function (t) { return t.trim(); });
          var custom = false, sticker = '', syn = [];
          tags.forEach(function (t) {
            if (CUSTOM_TAGS.indexOf(t) > -1) custom = true;
            if (t.indexOf('_sticker_') === 0) sticker = t.slice(9);
            if (SYNONYMS[t]) syn.push(SYNONYMS[t]);
          });
          var kw = KEYWORDS[String(p.id)];
          kw = Array.isArray(kw) ? kw.join(' ') : String(kw || '');
          (p.variants || []).forEach(function (v) {
            info[String(v.id)] = {
              price: parseFloat(v.price),
              metal: metalOf(v, p),
              custom: custom,
              sticker: sticker,
              title: [p.title, v.option1, v.option2, v.option3].join(' '),
              keywords: kw + ' ' + syn.join(' ')
            };
          });
        });
      })
      .catch(function () { /* cards still render, just without price labels */ });
  }

  /* ----- header ----- */
  function setupHeader() {
    var starting = form.querySelector('.charm-builder-description');
    var title = meta.querySelector('.product-single__title');
    // The theme's square, swipeable gallery stays exactly as on every other
    // PDP (both arms); only the meta column below it is restyled.
    if (starting && title) {
      starting.classList.add('wf-b8-starting');
      title.parentNode.insertBefore(starting, title.nextSibling);
    }
  }

  /* ----- quick start (V4 cards render async — decorate when they land) ----- */
  function decorateBundles(wrap) {
    if (wrap.classList.contains('wf-b8-done')) return;
    wrap.classList.add('wf-b8-done');
    var head = wrap.querySelector('.ab-v4-bundles__header');
    var title = wrap.querySelector('.ab-v4-bundles__title');
    if (title) title.textContent = 'Quick start · Pick a set';
    if (head) head.appendChild(el('span', 'wf-b8-or', 'or build your own below'));
    var cards = wrap.querySelectorAll('.ab-v4-bundle-card');
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      var isByo = c.getAttribute('data-bundle-id') === 'build-your-own';
      var name = c.querySelector('.ab-v4-bundle-card__name');
      var price = c.querySelector('.ab-v4-bundle-card__price');
      var btn = c.querySelector('.ab-v4-bundle-card__select');
      var infoBox = c.querySelector('.ab-v4-bundle-card__info') || c;
      if (name) name.parentNode.insertBefore(el('div', 'wf-b8-card-sub', isByo ? 'Pick any charms' : '4 charms + base'), name.nextSibling);
      var row = el('div', 'wf-b8-card-row');
      row.appendChild(price || el('span', 'ab-v4-bundle-card__price', ''));
      if (btn) {
        btn.textContent = isByo ? 'Build' : 'Use set';
        row.appendChild(btn);
      }
      infoBox.appendChild(row);
    }
  }

  /* ----- step 1: base ----- */
  // "Build" on the Build Your Own tile: V4 scrolls the step-1 title to the
  // header offset, which in this layout lands mid-way through the quick-start
  // row. Land the step-1 row right under the sticky header instead, i.e.
  // just below the divider that closes the quick-start section.
  function stickyHeaderHeight() {
    // #shopify-section-header is the sticky wrapper (94px at the top of the
    // page with the announcement bar, 63px once that has scrolled away)
    var els = [document.getElementById('shopify-section-header'), document.querySelector('.site-header')];
    for (var i = 0; i < els.length; i++) {
      if (!els[i]) continue;
      var pos = getComputedStyle(els[i]).position;
      if (pos === 'sticky' || pos === 'fixed') return els[i].getBoundingClientRect().height;
    }
    return 0;
  }
  function scrollToStep1() {
    var row = form.querySelector('.wf-b8-row') || step1Title;
    if (!row) return;
    // +6: the row's top edge tucks 6px under the header so the divider that
    // closes the quick-start section is hidden behind it, not peeking out
    function target() { return row.getBoundingClientRect().top + window.pageYOffset - stickyHeaderHeight() + 6; }
    try { window.scrollTo({ top: target(), behavior: 'smooth' }); } catch (e) { window.scrollTo(0, target()); }
    // the header shrinks by the announcement bar mid-scroll — settle exactly
    setTimeout(function () {
      var t = target();
      if (Math.abs(window.pageYOffset - t) > 3) window.scrollTo(0, t);
    }, 700);
  }
  function relabelStep1() {
    if (!step1Title || step1Title.classList.contains('wf-b8-relabeled')) return;
    step1Title.classList.add('wf-b8-relabeled');
    step1Title.innerHTML = '<span class="wf-b8-num">1 ·</span> Choose your base';
    if (baseTypes && baseTypes.parentNode && !step1Title.parentNode.classList.contains('wf-b8-row')) {
      var row = el('div', 'wf-b8-row');
      step1Title.parentNode.insertBefore(row, step1Title);
      row.appendChild(step1Title);
      row.appendChild(baseTypes);
    }
  }
  // Base colourways whose name carries no metal but whose hardware does
  // (the V4 bundle config maps the keeper bracelet the same way).
  var BASE_COLOR_METAL = { multi: 'Gold', aurora: 'Gold', turquoise: 'Silver' };
  function metalFromBase(item) {
    var s = item ? (item.querySelector('.charm-type-name') || item).textContent : '';
    if (/gold/i.test(s)) return 'Gold';
    if (/silver/i.test(s)) return 'Silver';
    var color = (s.split(' - ').pop() || '').trim().toLowerCase();
    return BASE_COLOR_METAL[color] || '';
  }
  var baseFallbackArmed = false;
  function decorateBases() {
    if (!baseBox) return;
    var items = baseBox.querySelectorAll('.base-item');
    // The engine auto-clicks the FIRST base tile; when that tile is out of
    // stock (pointer-events: none) nothing gets selected and the set has no
    // base. Once, on the initial render only, fall back to the first
    // in-stock tile. Never on a Bracelets/Necklaces switch (the earlier
    // pick stays selected in the engine, as in control).
    if (!baseFallbackArmed && items.length) {
      baseFallbackArmed = true;
      setTimeout(function () {
        if (baseBox.querySelector('.base-active') || resultBox.querySelector('[data-uuid="DEFAULT"]')) return;
        var first = baseBox.querySelector('.base-item:not(.oos-disabled)');
        if (first) first.click();
      }, 1500);
    }
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      it.setAttribute('aria-pressed', it.classList.contains('base-active') ? 'true' : 'false');
      if (it.querySelector('.wf-b8-price')) continue;
      var p = parseFloat(it.getAttribute('data-price'));
      var cmp = parseFloat(it.getAttribute('data-compare-price'));
      var html = isNaN(p) ? '' : (cmp > p ? '<s>' + txt(money(cmp)) + '</s> ' : '') + txt(money(p));
      it.appendChild(el('div', 'wf-b8-price', html));
    }
  }

  /* ----- step 2: toolbar ----- */
  function setupStep2() {
    if (step2Title) {
      var free = step2Title.querySelector('.charm-builder-free');
      step2Title.innerHTML = '<span class="wf-b8-num">2 ·</span> Add your charms ' + (free ? free.outerHTML : '');
    }
    var container = charmsBox.parentNode; // .charm-item-container
    var tabs = container.querySelector('.charm-type-selector');

    var search = el('label', 'wf-b8-search',
      '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="#595959" stroke-width="1.8" aria-hidden="true" focusable="false"><circle cx="11" cy="11" r="7"></circle><path d="M16.5 16.5 21 21"></path></svg>' +
      '<span class="visually-hidden">Search charms</span>' +
      '<input type="search" class="wf-b8-search-input" autocomplete="off" autocorrect="off" spellcheck="false" placeholder="Search 100+ charms — “initial”, “birthstone”…">');
    container.insertBefore(search, tabs || charmsBox);
    searchInput = search.querySelector('input');
    var debounce = null;
    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.keyCode === 13) e.preventDefault(); // never submit the ATC form
    });
    searchInput.addEventListener('input', function () {
      clearTimeout(debounce);
      debounce = setTimeout(function () {
        state.q = searchInput.value || '';
        if (state.q.trim()) {
          var all = container.querySelector('.charm-item-type[data-type="all"]');
          if (all && !all.classList.contains('active')) { all.click(); return; } // re-render -> observer -> applyFilters
        }
        applyFilters(true);
      }, 120);
    });

    var chips = el('div', 'wf-b8-chips');
    chips.innerHTML =
      '<button type="button" class="wf-b8-chip" data-chip="metal" data-value="Silver" aria-pressed="false">Silver</button>' +
      '<button type="button" class="wf-b8-chip" data-chip="metal" data-value="Gold" aria-pressed="false">Gold</button>' +
      '<button type="button" class="wf-b8-chip" data-chip="under10" aria-pressed="false">Under $10</button>' +
      '<label class="wf-b8-sort"><span class="visually-hidden">Sort charms</span>' +
        '<select><option value="default">Best selling</option><option value="asc">Price: low – high</option><option value="desc">Price: high – low</option></select>' +
      '</label>';
    container.insertBefore(chips, charmsBox);
    chipEls.Silver = chips.querySelector('[data-value="Silver"]');
    chipEls.Gold = chips.querySelector('[data-value="Gold"]');
    chipEls.under10 = chips.querySelector('[data-chip="under10"]');
    sortSel = chips.querySelector('select');
    chips.addEventListener('click', function (e) {
      var b = e.target.closest('.wf-b8-chip');
      if (!b) return;
      if (b.getAttribute('data-chip') === 'metal') {
        var v = b.getAttribute('data-value');
        state.metal = state.metal === v ? '' : v;
        state.metalTouched = true;
      } else {
        state.under10 = !state.under10;
      }
      syncChips();
      applyFilters(true);
    });
    sortSel.addEventListener('change', function () {
      state.sort = sortSel.value;
      applyFilters(true);
    });

    // Lazy load, no visible pager: the strip's column width leaves a partial
    // card showing at its right edge as the scroll affordance, and the next
    // batch loads as the shopper nears the end — on strip scroll (touch,
    // wheel, arrow keys on the focused region) or when keyboard focus lands
    // on one of the last visible cards (Tab also scrolls the strip). The
    // status region announces the running "Showing X of Y".
    emptyMsg = el('p', 'wf-b8-empty', 'No charms match — try another search.');
    emptyMsg.hidden = true;
    container.insertBefore(emptyMsg, charmsBox.nextSibling);
    function loadMore() {
      if (remaining <= 0) return;
      state.cap += PAGE_STEP;
      applyFilters(false);
    }
    var nearEnd = raf(function () {
      if (charmsBox.scrollLeft + charmsBox.clientWidth >= charmsBox.scrollWidth - 480) loadMore();
    });
    charmsBox.addEventListener('scroll', nearEnd, { passive: true });
    charmsBox.addEventListener('focusin', function (e) {
      var card = e.target && e.target.closest && e.target.closest('.charm-type-option');
      if (!card) return;
      var vis = cardList().filter(function (c) { return !c.classList.contains('wf-b8-hidden'); });
      if (vis.indexOf(card) >= vis.length - 6) loadMore();
    });

    statusEl = el('div', 'visually-hidden');
    statusEl.setAttribute('role', 'status');
    statusEl.setAttribute('aria-live', 'polite');
    container.appendChild(statusEl);

    // Click routing inside the charm grid.
    //  - The engine's stepper spans are purely visual in control (its
    //    full-tile overlay halves sit above them and do the work). Arm B
    //    lifts the stepper above the overlay so it reads as a real control,
    //    so route "+" to the right overlay (add) and "-" to the left overlay
    //    (remove). The engine's own '-' handler references an undefined
    //    variable and throws, so stopPropagation keeps it out of the way.
    //  - wf-a11y.js makes each tile a role=button and clicks the TILE on
    //    Enter/Space, but the engine listens on the overlay — forward.
    function forwardClick(node) {
      if (!node) return;
      forwarding = true;
      try { node.click(); } finally { forwarding = false; }
    }
    form.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest || !charmsBox.contains(t)) return;
      var card = t.closest('.charm-type-option');
      if (!card) return;
      var step = t.closest('.charm-quantity-subtract, .charm-quantity-add');
      if (step) {
        e.stopPropagation();
        forwardClick(card.querySelector(step.classList.contains('charm-quantity-add') ? '.inner-layer-right' : '.inner-layer-left'));
        return;
      }
      if (t.closest('.charm-quantity-selector')) {
        // the pill's own padding / the number: inert, never "one more"
        e.stopPropagation();
        return;
      }
      if (!forwarding && t.closest('.inner-layer-right') &&
          card.querySelector('.charm-quantity-selector') && !card.classList.contains('wf-b8-custom')) {
        // Already in the set: a second tap on the card is a no-op (the
        // stepper changes quantity). Left as-is for custom charms, where the
        // engine's tap opens the personalizer to add another one.
        e.stopPropagation();
        return;
      }
      if (t === card) forwardClick(card.querySelector('.inner-layer-right'));
    });

    // Base selection drives the default metal filter until the user touches the chips.
    form.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('.base-item');
      if (!b || state.metalTouched) return;
      var m = metalFromBase(b);
      if (m !== state.metal) {
        state.metal = m;
        syncChips();
        applyFilters(true);
      }
    });
  }
  function syncChips() {
    chipEls.Silver.setAttribute('aria-pressed', state.metal === 'Silver' ? 'true' : 'false');
    chipEls.Gold.setAttribute('aria-pressed', state.metal === 'Gold' ? 'true' : 'false');
    chipEls.under10.setAttribute('aria-pressed', state.under10 ? 'true' : 'false');
  }

  /* ----- step 2: charm cards ----- */
  function cardList() {
    return Array.prototype.filter.call(charmsBox.children, function (c) {
      return c.classList && c.classList.contains('charm-type-option');
    });
  }
  function decorateCharms() {
    var cards = cardList();
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      if (!c.hasAttribute('data-wf-order')) c.setAttribute('data-wf-order', c.style.order || '');
      if (c.classList.contains('wf-b8-done')) continue;
      c.classList.add('wf-b8-done');
      var vi = info[String(c.getAttribute('data-variant-id'))] || {};
      var nameEl = c.querySelector('.charm-type-name');
      var name = nameEl ? nameEl.textContent.trim() : '';
      var tRuns = runsOf(name + ' ' + (vi.title || ''));
      var kRuns = runsOf(vi.keywords || '');
      c.__wfIdx = { title: tRuns, all: tRuns.concat(kRuns) };
      c.setAttribute('data-wf-metal', vi.metal || '');
      c.setAttribute('data-wf-price', isNaN(vi.price) ? '' : String(vi.price));
      if (vi.custom) c.classList.add('wf-b8-custom');
      c.appendChild(el('div', 'wf-b8-meta',
        '<span class="wf-b8-price">' + txt(money(vi.price)) + '</span>' +
        (vi.custom ? '<span class="wf-b8-tag">Personalize</span>' : '')));
      if (vi.sticker) c.appendChild(el('div', 'wf-b8-badge', txt(vi.sticker)));
    }
  }
  /* ----- search matching -----
     Shoppers type "birth stone", "pavé", "mother's", "initi" and "hearts".
     Index and query go through the same normaliser (lowercase, accents
     stripped, apostrophes dropped, hyphens/punctuation -> space). A field is
     indexed as the runs of its words joined from every start position
     ("birth stone charm" -> "birthstonecharm", "stonecharm", "charm"), so a
     query token prefix-matches a word AND "birthstone" matches "birth stone"
     in either direction. Multi-word queries must land every token somewhere
     ("pink heart"), or match as one run ("birth stone"). A trailing "s"/"es"
     is forgiven so "hearts" finds "heart". */
  function norm(s) {
    s = String(s == null ? '' : s).toLowerCase();
    if (s.normalize) s = s.normalize('NFD').replace(/[̀-ͯ]/g, '');
    return s.replace(/[’']/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function runsOf(text) {
    var words = norm(text).split(' ').filter(Boolean), runs = [];
    for (var i = 0; i < words.length; i++) runs.push(words.slice(i).join(''));
    return runs;
  }
  function startsAt(runs, s) {
    for (var i = 0; i < runs.length; i++) if (runs[i].indexOf(s) === 0) return true;
    return false;
  }
  function tokenHits(runs, t) {
    if (startsAt(runs, t)) return true;
    if (t.length > 3 && t.charAt(t.length - 1) === 's') {
      if (startsAt(runs, t.slice(0, -1))) return true;
      if (t.slice(-2) === 'es' && startsAt(runs, t.slice(0, -2))) return true;
    }
    return false;
  }
  function parseQuery(q) {
    var raw = norm(q).split(' ').filter(Boolean);
    if (!raw.length) return null;
    // "day of the dead" -> day dead; keep the words if the query is ONLY stopwords
    var tokens = raw.filter(function (t) { return !STOPWORDS[t]; });
    if (!tokens.length) tokens = raw;
    tokens = tokens.map(function (t) { return QUERY_ALIASES[t] || t; });
    return { tokens: tokens, joined: tokens.join('') };
  }
  function fieldHits(runs, pq) {
    if (pq.tokens.length > 1 && startsAt(runs, pq.joined)) return true;
    for (var i = 0; i < pq.tokens.length; i++) if (!tokenHits(runs, pq.tokens[i])) return false;
    return true;
  }
  // 0 = title/option hit, 1 = keyword (or mixed) hit, -1 = no match
  function rankOf(c, pq) {
    var ix = c.__wfIdx;
    if (!ix) return -1;
    if (fieldHits(ix.title, pq)) return 0;
    if (fieldHits(ix.all, pq)) return 1;
    return -1;
  }
  function orderOf(c) {
    var n = parseInt(c.getAttribute('data-wf-order'), 10);
    return isNaN(n) ? 0 : n;
  }
  function applyFilters(resetCap) {
    if (!charmsBox) return;
    if (resetCap) state.cap = PAGE_FIRST;
    var cards = cardList();
    var pq = parseQuery(state.q);
    var q = !!pq;
    var matches = [];
    cards.forEach(function (c) {
      var ok = true;
      if (pq) {
        c.__wfRank = rankOf(c, pq);
        if (c.__wfRank < 0) ok = false;
      }
      if (ok && state.metal) {
        var m = c.getAttribute('data-wf-metal');
        if (m && m !== state.metal) ok = false;
      }
      if (ok && state.under10) {
        var p = parseFloat(c.getAttribute('data-wf-price'));
        if (!isNaN(p) && p >= 10) ok = false;
      }
      if (ok) matches.push(c); else c.classList.add('wf-b8-hidden');
    });
    var ordered = matches;
    var priced = state.sort === 'asc' || state.sort === 'desc';
    if (priced || pq) {
      // price sort (when chosen) > title hits before keyword hits > catalog order
      var dir = state.sort === 'asc' ? 1 : -1;
      ordered = matches.slice().sort(function (a, b) {
        if (priced) {
          var pa = parseFloat(a.getAttribute('data-wf-price')), pb = parseFloat(b.getAttribute('data-wf-price'));
          if (isNaN(pa)) pa = Infinity; if (isNaN(pb)) pb = Infinity;
          if (pa !== pb) return (pa - pb) * dir;
        }
        if (pq && a.__wfRank !== b.__wfRank) return a.__wfRank - b.__wfRank;
        return orderOf(a) - orderOf(b);
      });
      ordered.forEach(function (c, i) { c.style.order = String(i); });
    } else {
      cards.forEach(function (c) { c.style.order = c.getAttribute('data-wf-order') || ''; });
    }
    var cap = q ? Infinity : state.cap;
    var shown = 0;
    ordered.forEach(function (c, i) {
      if (i < cap) { c.classList.remove('wf-b8-hidden'); shown++; }
      else c.classList.add('wf-b8-hidden');
    });
    remaining = ordered.length - shown;
    emptyMsg.hidden = ordered.length > 0 || cards.length === 0;
    if (statusEl) statusEl.textContent = cards.length ? ('Showing ' + shown + ' of ' + ordered.length + ' charms') : '';
  }
  // The engine re-renders the grid from scratch on every tab click and does
  // not put the stepper back on cards whose variant is already in the set
  // (control shows them as unselected; a further click resets that variant
  // to qty 1). Rebuild the stepper from the result list so the card state
  // stays truthful — the injected markup is byte-for-byte the engine's own,
  // with data-quantity = the count the engine holds for that variant.
  function restoreSelections() {
    var counts = {};
    var rows = resultBox.querySelectorAll('.charm-type-option');
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].getAttribute('data-uuid') === 'DEFAULT') continue;
      var id = String(rows[i].getAttribute('data-variant-id'));
      counts[id] = (counts[id] || 0) + 1;
    }
    cardList().forEach(function (c) {
      var n = counts[String(c.getAttribute('data-variant-id'))] || 0;
      if (!n || c.querySelector('.charm-quantity-selector') || c.querySelector('.oos-badge')) return;
      var img = c.querySelector('.charm-img-container');
      if (!img) return;
      var add = c.querySelector('.charm-add');
      if (add) add.parentNode.removeChild(add);
      img.insertAdjacentHTML('beforeend',
        '<div class="charm-quantity-selector" data-quantity="' + n + '"><div class="charm-selector-controls">' +
        '<span class="charm-quantity-subtract">-</span><span class="charm-quantity">' + n + '</span>' +
        '<span class="charm-quantity-add">+</span></div></div>');
    });
  }
  function syncSelected() {
    var cards = cardList();
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      var sel = !!c.querySelector('.charm-quantity-selector');
      c.classList.toggle('wf-b8-selected', sel);
      var badge = c.querySelector('.wf-b8-count');
      if (sel) {
        var qEl = c.querySelector('.charm-quantity');
        var n = qEl ? qEl.textContent.trim() : '1';
        if (!badge) {
          badge = el('span', 'wf-b8-count');
          badge.setAttribute('aria-hidden', 'true');
          c.appendChild(badge);
        }
        if (badge.textContent !== n) badge.textContent = n;
        // The stepper is a pointer affordance that duplicates what the tile
        // (role=button: add one more) and the summary bar's real "Remove …"
        // buttons already expose — keep it out of the a11y tree so the tile
        // isn't a button containing buttons (axe: nested-interactive).
        var stepper = c.querySelector('.charm-quantity-selector');
        if (stepper && !stepper.hasAttribute('aria-hidden')) stepper.setAttribute('aria-hidden', 'true');
      } else if (badge) {
        badge.parentNode.removeChild(badge);
      }
    }
  }

  /* ----- sticky summary bar (mirrors the engine's hidden step-3 list) ----- */
  function setupBar() {
    var review = resultBox.closest('.charm-builder-section');
    if (review) {
      review.classList.add('wf-b8-review');
      var prev = review.previousElementSibling;
      if (prev && prev.classList.contains('charm-separator')) prev.classList.add('wf-b8-review');
    }
    var realAtc = form.querySelector('.add-to-cart-btn');
    if (realAtc) realAtc.classList.add('wf-b8-gone');

    bar = el('div', 'wf-b8-bar');
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Your charm set');
    bar.innerHTML =
      '<div class="wf-b8-bar-top">' +
        '<ul class="wf-b8-thumbs"></ul>' +
        '<div class="wf-b8-total" aria-live="polite"><div class="wf-b8-total-label"></div><div class="wf-b8-total-price"></div></div>' +
      '</div>' +
      // .add-to-cart-btn: the engine's delegated body handler builds the cart
      // payload from the (hidden) result list and preventDefaults — no proxy.
      '<button type="button" class="wf-b8-atc add-to-cart-btn"><span>Add Set to Cart</span></button>';
    form.appendChild(bar);
    barThumbs = bar.querySelector('.wf-b8-thumbs');
    barLabel = bar.querySelector('.wf-b8-total-label');
    barPrice = bar.querySelector('.wf-b8-total-price');
    barBtn = bar.querySelector('.wf-b8-atc');

    barThumbs.addEventListener('click', function (e) {
      var x = e.target.closest('.wf-b8-x');
      if (!x) return;
      var rows = resultBox.querySelectorAll('.charm-type-option');
      var row = rows[parseInt(x.getAttribute('data-idx'), 10)];
      var rm = row && row.querySelector('.inner-layer-remove');
      if (rm) rm.click();
    });

    // the engine toggles is-adding / disabled on every .add-to-cart-btn
    var addedTimer = null;
    new MutationObserver(function () {
      var busy = barBtn.disabled || barBtn.classList.contains('is-adding');
      var added = !busy && barBtn.classList.contains('is-added');
      barBtn.firstChild.textContent = busy ? 'Adding…' : (added ? 'Added to cart' : 'Add Set to Cart');
      if (added && !addedTimer) {
        addedTimer = setTimeout(function () { addedTimer = null; barBtn.classList.remove('is-added'); }, 3000);
      }
    }).observe(barBtn, { attributes: true, attributeFilter: ['disabled', 'class'] });

    // html.wf-b8-stuck while the bar is pinned to the viewport bottom (a 1px
    // sentinel right after it sits below the fold) — CSS lifts the floating
    // chat launcher above the bar only then, so it never covers the CTA.
    // Scroll-driven rather than an IntersectionObserver: a jump that skips
    // straight over the 1px sentinel never changes its intersection state.
    var sentinel = el('div', 'wf-b8-sentinel');
    sentinel.setAttribute('aria-hidden', 'true');
    form.appendChild(sentinel);
    // The bar stays out of the way until the shopper reaches step 2 (its
    // title within ~120px of the bottom of the viewport) — before that there
    // is nothing to add. Once the set holds a charm it stays visible.
    function barWanted() {
      if (resultBox.querySelector('.charm-type-option:not([data-uuid="DEFAULT"])')) return true;
      if (!step2Title) return true;
      return step2Title.getBoundingClientRect().top < window.innerHeight - 120;
    }
    var updateStuck = raf(function () {
      var wanted = barWanted();
      bar.classList.toggle('wf-b8-bar-hidden', !wanted);
      var top = sentinel.getBoundingClientRect().top;
      var stuck = wanted && top > window.innerHeight;
      document.documentElement.classList.toggle('wf-b8-stuck', stuck);
      document.documentElement.style.setProperty('--wf8-bar-h', bar.offsetHeight + 'px');
    });
    window.addEventListener('scroll', updateStuck, { passive: true });
    window.addEventListener('resize', updateStuck, { passive: true });
    bar.__updateStuck = updateStuck;
    updateStuck();
  }
  function renderBar() {
    if (!bar) return;
    var rows = resultBox.querySelectorAll('.charm-type-option');
    var active = baseBox && baseBox.querySelector('.base-item.base-active');
    var basePrice = active ? parseFloat(active.getAttribute('data-price')) : NaN;
    var html = '', total = 0, charms = 0, hasBase = false;
    for (var i = 0; i < rows.length; i++) {
      var it = rows[i];
      var img = it.querySelector('img');
      var nameEl = it.querySelector('.charm-type-name');
      var name = nameEl && nameEl.firstChild ? nameEl.firstChild.textContent.trim() : (nameEl ? nameEl.textContent.trim() : '');
      var isBase = it.getAttribute('data-uuid') === 'DEFAULT';
      var price;
      if (isBase) {
        hasBase = true;
        price = isNaN(basePrice) ? parsePrice(nameEl) : basePrice;
      } else {
        charms++;
        var vi = info[String(it.getAttribute('data-variant-id'))];
        price = vi && !isNaN(vi.price) ? vi.price : parsePrice(nameEl);
      }
      if (!isNaN(price)) total += price;
      html += '<li class="wf-b8-thumb">' +
        '<img src="' + txt(img ? img.getAttribute('src') : '') + '" alt="' + txt(name) + '" loading="lazy">' +
        (isBase ? '' : '<button type="button" class="wf-b8-x" data-idx="' + i + '" aria-label="Remove ' + txt(name) + '">&times;</button>') +
        '</li>';
    }
    barThumbs.innerHTML = html || '<li class="wf-b8-empty-thumbs">Pick a base, then add charms</li>';
    barLabel.textContent = hasBase
      ? 'Base + ' + charms + ' charm' + (charms === 1 ? '' : 's')
      : charms + ' charm' + (charms === 1 ? '' : 's');
    barPrice.textContent = money(total);
    if (bar.__updateStuck) bar.__updateStuck(); // bar height + visibility follow the set
  }

  /* ----- boot ----- */
  function whenBundles(cb) {
    var done = false;
    function fire() { if (done) return; done = true; cb(form.querySelector('.ab-v4-bundles')); }
    if (form.querySelector('.ab-v4-bundles')) { fire(); return; }
    var mo = new MutationObserver(function () {
      if (form.querySelector('.ab-v4-bundles')) { mo.disconnect(); fire(); }
    });
    mo.observe(form, { childList: true });
    setTimeout(function () { mo.disconnect(); fire(); }, 6000); // V4 offline -> relabel anyway
  }

  function init() {
    form = document.querySelector('form.add-to-cart-form');
    meta = form && form.closest('.product-single__meta');
    if (!form || !meta) return;
    charmsBox = form.querySelector('.charm-container-inner[data-type="charms"]');
    resultBox = form.querySelector('.charm-result-inner');
    baseBox = form.querySelector('.charm-base-selector-container');
    baseTypes = form.querySelector('.charm-base-selector-types');
    if (!charmsBox || !resultBox) return;
    var titles = form.querySelectorAll('.charm-builder-title');
    for (var i = 0; i < titles.length; i++) {
      var t = titles[i].textContent.replace(/\s+/g, ' ');
      if (!step1Title && t.indexOf('SELECT YOUR BASE') > -1) step1Title = titles[i];
      else if (!step2Title && /Select Your Charms/i.test(t)) step2Title = titles[i];
    }

    setupHeader();
    setupStep2();
    setupBar();

    // V4 finds its insertion point by the "SELECT YOUR BASE" text and inserts
    // BEFORE that node — relabel/wrap step 1 only once its cards are in.
    whenBundles(function (wrap) {
      if (wrap) decorateBundles(wrap);
      relabelStep1();
    });
    // capture phase: runs before V4's own listener on the button, which we
    // then keep from firing so the two scrolls do not fight
    form.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('.ab-v4-byo-btn');
      if (!b) return;
      e.stopPropagation();
      e.preventDefault();
      scrollToStep1();
    }, true);

    var onCharmsMutation = raf(function () { syncSelected(); });
    function isCard(n) { return n.nodeType === 1 && n.classList.contains('charm-type-option'); }
    new MutationObserver(function (muts) {
      // a re-render = charm cards added/removed directly under the strip
      var rerendered = false;
      for (var i = 0; i < muts.length && !rerendered; i++) {
        var m = muts[i];
        if (m.type !== 'childList' || m.target !== charmsBox) continue;
        rerendered = Array.prototype.some.call(m.addedNodes, isCard) || Array.prototype.some.call(m.removedNodes, isCard);
      }
      if (rerendered && catalogReady) { decorateCharms(); restoreSelections(); applyFilters(true); }
      onCharmsMutation();
    }).observe(charmsBox, { childList: true, subtree: true, characterData: true });

    var onBaseMutation = raf(function () { decorateBases(); renderBar(); });
    if (baseBox) new MutationObserver(onBaseMutation).observe(baseBox, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });

    var onResultMutation = raf(renderBar);
    new MutationObserver(onResultMutation).observe(resultBox, { childList: true });

    decorateBases();
    renderBar();
    loadCatalog().then(function () {
      catalogReady = true;
      decorateCharms();
      restoreSelections();
      applyFilters(true);
      syncSelected();
      renderBar();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
